import { render, staticRenderFns } from "./PreviewButton.vue?vue&type=template&id=5c6e0768&"
import script from "./PreviewButton.vue?vue&type=script&lang=ts&"
export * from "./PreviewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports